import axios from "axios";

import {
  reducerVisitSchedulaStatus,
  reducerVisitScheduleData,
} from "../../reducer/userSingleReport/reducers/visitSchedule";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetVisitScheduleData =
  (limit: number, page: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;

      const store = getState();
      const filter = store.userSingleReport.visitSchedule.visitScheduleInputValues;

      try {
        const response = await axios.post(`${BASE_URL}/json/contracts/schedule`, {
          ...filter,
          limit,
          page,
        });

        dispatch(reducerVisitScheduleData({ data: response.data, limit, page: 1 }));
      } catch {
        console.log('err');
      };
    };

export const actionUnloadScheduleInExcel =
  () => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const contract = store.userSingleReport.visitSchedule.contract;
    try {
      const response = await axios.post(
        `${BASE_URL}/json/contracts/schedule/export`, {
        contract,
        page: 1,
      }
      );
      dispatch(reducerVisitSchedulaStatus(response.status));
    } catch (err) {
      dispatch(reducerVisitSchedulaStatus(0));
    }
  };
